import React from 'react';

import BlogPostCard from '@/components/route/blog/BlogPostCard/BlogPostCard';
import { IBlogPost } from '@/services/types/blog/post.types';

interface IFeaturedPost {
  posts: IBlogPost[];
}

const FeaturedPosts: React.FC<IFeaturedPost> = ({ posts }) => {
  return (
    <div className="mb-12 grid grid-cols-1 gap-6 lg:grid-cols-6">
      <div className="lg:row-span-2 lg:col-span-4">
        <BlogPostCard
          ratio="825:475"
          // @ts-expect-error fixable: unchecked index access
          post={posts[0]}
        />
      </div>
      {posts.slice(1, 3).map(p => (
        <div key={p.id} className="lg:row-span-1 lg:col-span-2">
          <BlogPostCard ratio="25:14" post={p} />
        </div>
      ))}
    </div>
  );
};

export default FeaturedPosts;
